"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalIdentityCreateSchema = exports.ExternalIdentityIMSchema = void 0;
const externalidentity_1 = require("../core-model-schemas/externalidentity");
exports.ExternalIdentityIMSchema = externalidentity_1.ExternalIdentitySchema.omit({
    id: true,
    userId: true,
});
exports.ExternalIdentityCreateSchema = externalidentity_1.ExternalIdentitySchema.omit({
    userId: true,
    id: true,
    externalId: true,
});
